import { Metadata } from '../../../../../utils/spds/metadata';
import Super from '../base.gjs';
import styles from './brand.module.scss';

const METADATA = Metadata.define({
  description: 'Primary brand badge indicator.',
  name: 'Brand Primary Badge',
});

export default class SpdsIndicatorBadgeBrandPrimary extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  variantClass = 'spds-indicator-badge-brand';
  variantStyles = styles;
}

export const BADGE_BRAND_PRIMARY_METADATA = SpdsIndicatorBadgeBrandPrimary.metadata;
